import {
  Button,
  Typography,
  Header,
  Spacing,
  MyTextInput,
} from 'components/src';
import React, {
  FC,
  memo,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { BackHandler } from 'react-native';
import { Platform, createUseStyles, useLang } from 'core/src';
import { StackNavigationProp } from '@react-navigation/stack';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import { useTranslation } from 'react-i18next';

const MaterialIconsX = MaterialIcons as unknown as React.ComponentType<any>;

interface ContentHeaderProps {
  navigation: StackNavigationProp<any>;
  setSearchText: any;
  setOpen: any;
}

const ContactHeader: FC<ContentHeaderProps> = memo(
  ({ navigation, setSearchText, setOpen }) => {
    const { styles, colors } = useStyles();
    const { lang } = useLang();
    const [search, setSearch] = useState<boolean>(false);
    const { i18n } = useTranslation();
    const typingTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const handleBack = () => {
      search
        ? setSearch(false)
        : Platform.isDesktop
          ? setOpen('')
          : navigation.goBack();
    };

    useEffect(() => {
      !search && setSearchText('');
    }, [search]);

    const handleSearchChange = useCallback(
      (text: any) => {
        if (typingTimeoutRef.current) {
          clearTimeout(typingTimeoutRef.current);
        }
        typingTimeoutRef.current = setTimeout(() => {
          setSearchText(text);
        }, 1500);
      },
      [setSearchText],
    );

    useEffect(() => {
      const handleBrowserBack = () => {
        handleBack();
      };

      const handleMobileBack = () => {
        handleBack();
        return true; // Prevent default behavior
      };

      // Add browser back button listener
      window.addEventListener('popstate', handleBrowserBack);

      // Add mobile back button listener
      BackHandler.addEventListener('hardwareBackPress', handleMobileBack);

      return () => {
        // Cleanup listeners
        window.removeEventListener('popstate', handleBrowserBack);
        BackHandler.removeEventListener('hardwareBackPress', handleMobileBack);
      };
    }, [handleBack]);

    return (
      <Header
        classes={{
          flexDirection: lang === 'fa-IR' ? 'row-reverse' : 'row',
        }}
      >
        <Button onClick={handleBack}>
          <MaterialIconsX name="arrow-back" size={25} color={colors.white} />
        </Button>
        {search ? (
          <>
            <Spacing horizontal={7} />
            <MyTextInput
              change={handleSearchChange}
              classes={styles.input}
              placeholder={i18n.t('search...')}
              focus={search ? true : false}
            />
          </>
        ) : (
          <>
            <Typography text={i18n.t('newMessage')} color={colors.white} />
          </>
        )}
        <Button
          onClick={() => {
            setSearch(true);
          }}
        >
          <MaterialIconsX name="search" size={25} color={colors.white} />
        </Button>
      </Header>
    );
  },
);
const useStyles = createUseStyles(({ colors, theme }) => ({
  input: {
    flex: 1,
    backgroundColor: 'transparent',
    elevation: 0,
    textAlign: 'left',
  },
}));

export { ContactHeader };
